export enum WorkflowSignatureReason {
  APPROVAL = "APPROVAL",
  REJECTION = "REJECTION",
  FAILURE = "FAILURE",
  NO_REVISION = "NO_REVISION",
  REVISION_NEEDED = "REVISION_NEEDED",
  ARCHIVE = "ARCHIVE"
}
